import { SpaceCategory } from "@lifeat/shared/data-models/virtual-space/SpaceCategory";
import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum SpaceEvent {
    SPACE_EVENT = "space_event",

    SAVE_SPACE = "save_space",
    SELECT_SAVED_SPACE = "select_saved_space",

    COPY_SPACE_LINK = "copy_space_link",
    EXPLORE_SPACES_BTN_CLICK = "explore_spaces_btn_click",

    CHANGE_SPACE_CATEGORY = "change_space_category",

    VIEW_SPACES_SEARCH = "view_spaces_search",
    SEARCH_SPACES = "search_spaces",
    SELECT_SEARCHED_SPACE = "select_searched_space",

    SPACE_SHUFFLE_EVENT = "space_shuffle",
}

interface SpaceEventInfo {
    spaceId?: string;
    spaceName?: string;
    spaceCategory?: string;
    spaceCreator?: string;
}

interface SearchSpaceEventInfo {
    searchTerm: string;
}

/**
 * Records an event when shuffling spaces and switching to a different
 * category from that of the currently selected space
 */
export class ChangeCategoryEvent extends AmplitudeEvent {
    constructor(category: SpaceCategory, startTime: number, duration?: number) {
        super(SpaceEvent.CHANGE_SPACE_CATEGORY);
        this.props = { category, startTime, duration };
    }
}

export class SaveSpaceEvent extends AmplitudeEvent {
    constructor(spaceInfo: SpaceEventInfo) {
        super(SpaceEvent.SAVE_SPACE);
        this.props = spaceInfo;
    }
}

export class SelectSavedSpaceEvent extends AmplitudeEvent {
    constructor(spaceInfo: SpaceEventInfo) {
        super(SpaceEvent.SELECT_SAVED_SPACE);
        this.props = spaceInfo;
    }
}

export class ShareSpaceLinkEvent extends AmplitudeEvent {
    constructor(spaceInfo: SpaceEventInfo) {
        super(SpaceEvent.COPY_SPACE_LINK);
        this.props = spaceInfo;
    }
}

export class ClickExploreButtonEvent extends AmplitudeEvent {
    constructor() {
        super(SpaceEvent.EXPLORE_SPACES_BTN_CLICK);
    }
}

export class ViewSpacesSearchEvent extends AmplitudeEvent {
    constructor() {
        super(SpaceEvent.VIEW_SPACES_SEARCH);
    }
}

export class SearchSpaceEvent extends AmplitudeEvent {
    constructor(searchInfo: SearchSpaceEventInfo) {
        super(SpaceEvent.SEARCH_SPACES);
        this.props = searchInfo;
    }
}

export class SelectSearchedSpaceEvent extends AmplitudeEvent {
    constructor(searchInfo: SearchSpaceEventInfo, spaceInfo: SpaceEventInfo) {
        super(SpaceEvent.SELECT_SEARCHED_SPACE);
        this.props = { ...searchInfo, ...spaceInfo };
    }
}

export class SpaceShuffleEvent extends AmplitudeEvent {
    constructor(category: string, isChangingSpaceCategory: boolean) {
        super(SpaceEvent.SPACE_SHUFFLE_EVENT);
        this.props = { category, isChangingSpaceCategory };
    }
}

export class SelectSpaceEvent extends AmplitudeEvent {
    constructor(spaceInfo: SpaceEventInfo, source: "discover" | "favorites" | "search") {
        super("select_space");
        this.props = { ...spaceInfo, source };
    }
}
